import AttendeeAutocomplete from "components/AgencySelect/AttendeeAutocomplete"

type Props = {
  attendees: Attendee[]
  onChange: (attendees: Attendee[]) => void
}

const AttendanceSelect = ({ attendees, onChange }: Props) => {
  return (
    <AttendeeAutocomplete className="flex-1" label="Chọn nhân viên" multiple onChange={onChange} value={attendees} />
  )
}

export default AttendanceSelect
